import { css } from "@linaria/core";
import { makeSelectors } from "../../css/maker.selectors";
import { easings } from "../../css-tokens/easings";
import { combineTokens } from "../../css/util.combine-tokens";
import { makeScaleableToken } from "../../css/token.scaleable";
import { css as composableCss } from "../../css/util.compose-css";

export const sliderModifiers = makeSelectors({
  disableTransition: css``,
});

export const sliderTokens = combineTokens("--css-slider", {
  itemsPerPage: "3",
  itemMargin: "3rem",
  containerPadding: ["0rem", makeScaleableToken],

  transitionDurationBase: "0.45s",
  transitionDurationExtraPerItem: "0.1s",
});

export const disallowOverflowModifier = composableCss`
  overflow: hidden;
  content-visibility: auto;
`;

export const wrapper = css`
  position: relative;

  box-sizing: border-box;

  /** Extend area slightly to avoid overflow: hidden clipping transform/scale
      on children */
  margin: ${sliderTokens.containerPadding({ scale: -1 })};
  padding: ${sliderTokens.containerPadding()};
`;

export const slider = css`
  display: flex;
  gap: ${sliderTokens.itemMargin()};

  .${wrapper}:not(${sliderModifiers.disableTransition()}) & {
    transition: transform
      calc(
        ${sliderTokens.transitionDurationBase()} +
          ${sliderTokens.transitionDurationExtraPerItem()} *
          ${sliderTokens.itemsPerPage()}
      )
      ${easings.inOutQuad};
  }
`;

export const spacer = css`
  flex-shrink: 0;
`;
